import React from 'react';
import styled from 'styled-components';
import { primaryColor } from 'Utils/utilsStyle';

const Svg = styled.svg`
  &:hover {
    path {
      fill: ${primaryColor};
    }
  }
`;
const CloseIconFilled = function CloseIconFilled() {
  return (
    <Svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.8995 0L6.04969 3.8498L2.19989 0L0 2.19989L3.8498 6.04969L0 9.8995L2.19989 12.0994L6.04969 8.24958L9.8995 12.0994L12.0994 9.8995L8.24958 6.04969L12.0994 2.19989L9.8995 0Z" fill="#C5C5C5" />
    </Svg>

  );
};

export default CloseIconFilled;
